import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),

    },
    sectionContainer: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      alignContent: 'center',
    },
    outlinedSectionContainer: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      paddingBottom: theme.spacing(20),
    },
    boldedSection: {
      fontWeight: 'bold',
    },
    paperRoot: {
      paddingTop: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
    },
  }),
);

export default function AboutPage() {
  const classes = useStyles(baseTheme);
  return (
    <Grid item container direction="column" className={classes.root}>
      <Typography variant="h4" color="primary">
        About Reliht
      </Typography>
      <Grid item container>
        <Grid item container direction="column" xs={12} lg={12}>
          <section className={classes.outlinedSectionContainer}>
            <Typography variant="h5" color="primary">Equipping and Sharing</Typography>
            <p>
              Reliht was created out of our love for Jesus but also because of GOD’S
              LOVE FOR THE WORLD. The Lord spoke to our hearts, “share with others”
              and “equip leaders for the Kingdom of God”. It is our commission and
              joy to share Reliht with you, to ignite and “reliht” hearts for God again.
            </p>
            <p>
              We’ve made this platform for you, that you may record the many ways God
              speaks to you and confirms His Words, but also as a way for you to share,
              help equip and disciple others as a leader in the Kingdom of God.
            </p>
            <p>Reliht will compliment your social group, but is NOT a social platform.
              Reliht IS a place to grow with God and encourage others to do the same.
              You may think of it as your “away space” to record your “quiet time
              with God” and as a place to post — and share if you want — what is on
              your heart from the Lord as you spend time with Him.
            </p>
            <p>Our hope is that every one with a heart to share would have a platform
              and process where they can do that, and one without “social noise” and
              distraction. One post is where it starts — whether a private post, a
              closed group post or a public post.
            </p>
            <p>God can speak in a still small voice, in the beauty of a quiet moment,
              in a dream or a vision — in so many ways. The Reliht web and mobile app
              will help you write about your experience and revelation of JESUS, THE
              LIGHT OF THE WORLD, our HOPE, our SALVATION.
            </p>
            <p>Please invite your friends and family, church, co-workers — anyone who
              loves God or wants to learn more about Him — to use Reliht. Create posts
              — notes and highlights — store, read again, share and encourage others.
            </p>
            <p>May the Lord bless you and the many people you reach and may JESUS
              receive the GLORY. We pray this in His Name. AMEN.
            </p>
          </section>
          <section className={classes.sectionContainer}>
            <Typography
              variant="h6"
              color="primary"
              align="center"
              paragraph={true}
              className={classes.boldedSection}>
              I AM THE WAY, THE TRUTH, AND THE LIFE. JOHN 14:6
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              align="center"
              paragraph={true}
              className={classes.boldedSection}>
              If you’re here today, reading this page and you haven’t asked Jesus to
              be your Lord and Savior, He is knocking at your door.
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              align="center"
              paragraph={true}
              className={classes.boldedSection}>
              FOR GOD SO LOVED THE WORLD, THAT HE GAVE HIS ONLY BEGOTTEN SON, THAT
              WHOEVER BELIEVES IN HIM SHOULD NOT PERISH BUT HAVE EVERLASTING LIFE.
              FOR GOD DID NOT SEND HIS SON INTO THE WORLD TO CONDEMN THE WORLD,
              BUT THAT THE WORLD THROUGH HIM MIGHT BE SAVED. JOHN 3:16-17
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              align="center"
              paragraph={true}
              className={classes.boldedSection}>
              Jesus died for your sins, was resurrected after three days, and is
              alive and seated at the right hand of the Father today. When you
              accept Jesus Christ as your Savior and invite Him into your heart, His
              Holy Spirit lives inside of you and guides you. And He wants to be a
              part of every day.
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              align="center"
              paragraph={true}
              className={classes.boldedSection}>
              Ask Him in, receive Him into your heart, then listen for Him to speak.
              Write it down. He will give you more. You can trust in Him to lead you.
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              align="center"
              paragraph={true}
              className={classes.boldedSection}>
              Pray this:
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              align="center"
              paragraph={true}
              className={classes.boldedSection}>
              Jesus, I am a sinner and am sorry for my sins. Forgive me for trying to
              do this life on my own. Come into my heart today and be my Lord and Savior.
              I believe — through You, with You and in You.
            </Typography>
          </section>
        </Grid>
      </Grid>
    </Grid>
  );
}
